import React from "react";
import Images from "../../../../../../utils/images.js";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../ConnectionError/ConnectionErrorPage.scss";

const ConnectionErrorPage = ({ statusCode = 500, message }) => {
  let description = "An unknown error occurred while trying to connect.";
  if (message) {
    if (typeof message === 'object') {
      description = message.error_message || message.text || message.message || message.description || description;
    } else if (typeof message === 'string' && message.trim() !== "") {
      description = message;
    }
  }
  return (
    <div className="w-100 h-100 position-fixed d-flex justify-content-center align-items-center bg-white connection-error-page-wrapper" style={{ zIndex: 1050, top: 0, left: 0, backgroundColor: 'var(--theme-background, #ffffff)', color: 'var(--theme-text-primary, rgba(0, 0, 0, 0.87))' }}>
      <div className="d-flex flex-column sub_container">
        <div className="heading pb-5">Privilege and Access Management</div>
        <div className="row">
          <div className="col-md-5 my-auto">
            <div className="heading4">{statusCode}</div>
            <div className="heading3 pb-5 pt-4 mb-2">{description}</div>
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-5">
            <LazyLoadImage
              src={Images.Error400}
              title="Connection Error Indicator"
              alt="Error Page"
              className="w-100"
              effect="blur"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionErrorPage;
